<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    لیست بروزرسانی ها
                    <!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>

            <div class="card card-style text-center mb-3">
                <div class="content">

                    <div class="list-group list-custom-small list-icon-0">
                        <div class="list-group-div py-2" v-for="item in UpdateList" :key="item.NoticeId">
                            <div class="d-flex align-items-center justify-content-between">
                                <!--<input class="big-checkbox UserSelected" type="checkbox" :value="task.userId" :id="task.userId" :key="task.userId" />-->

                                <a class="border-0" target="_blank" :href="item.url">
                                    <div class="d-flex">
                                        <i class="fa fa-bullhorn text-primary px-3 float-none font-13 opacity-1"></i>
                                        <p class="mb-0 rtl text-right"> {{item.title}}</p>
                                    </div>
                                    <div class="d-flex">
                                        <i class="fa fa-barcode color-pink2-light px-3"></i>
                                        <p class="mb-0"> کد بروزرسانی: <b>{{item.code}}</b></p>
                                    </div>
                                </a>
                                <i class="fa fa-angle-left"></i>
                            </div>
                        </div>
                        <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
        <Help-Menu title="معرفی اپلیکیشن کارنگاشت" keyEn="TaskList"  v-if="isKarnegasht==true"></Help-Menu>
    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedTypeId: 0,
                pageLoaded: false
            };
        },
        computed: {
            UpdateList() {
                return this.$store.getters.GetUpdatesList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            }
        },

        created() {

            this.$store.dispatch("GetUpdatesListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {

            filterList() {
                this.page = 1;
                this.$store.dispatch("GetUpdatesListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },

            getNextPageUpdateList() {
                this.page++;
                this.$store.dispatch("GetUpdatesListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },


            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

            console.log("mounted");
            this.getNextPageUpdateList();

        }
    };
</script>
